import { FC } from 'react';
import { Button, } from '@mui/material';

import ModalDialog from "./ModalDialog";
import { useInfo } from '../../hooks/PopupContext';

const InfoModal: FC<void> = () => {
  const { onClose, infoState } = useInfo();
  const onClickClose = (id: string) => {
    if (id === 'btn-close') {
      onClose();
    }
  }
  return (
    <ModalDialog
      open={infoState.show}
      title={infoState.title}
      content={
        infoState.content
      }
      buttons={
        <>
          <Button color="primary" onClick={() => onClickClose('btn-close')} variant="contained" >
            OK
          </Button>
        </>
      }
      onClose={onClose}
      sxx={{ minHeight: 120, minWidth: 360 }}
    />
  );
};

export default InfoModal;